<template>
  <div :class="['form-group', !!error && 'has-error']">
    <label
      class="text-ontick-base text-light mb-1 block font-medium"
      for="email"
      >{{ label }}</label
    >
    <input
      :id="name"
      :name="name"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      :class="[error ? ' border-red-300 text-red-900 ' : 'border-gray-300', bg]"
      class="input_form focus:outline-none block block w-full w-full appearance-none rounded-md py-3 px-3 text-white shadow-lg focus:border-red-500 sm:text-sm"
      @blur="$emit('validate')"
      @keypress="$emit('validate')"
    />
    <p class="text-ontick-fifth text-ontick-small mt-1" v-if="!!error">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: "form-input",
  props: {
    type: { required: true },
    label: { required: true },
    placeholder: { required: false },
    name: { required: true },
    value: { required: true },
    error: { required: true },
    bg: {
      type: String,
      default: "bg-ontick-container",
    },
  },
};
</script>
